import { TOKEN_KEY } from "../authProvider";

// Web host app (Zego). Host opens role=host here; athletes join role=audience.
export const LIVE_HOST_URL =
  import.meta.env.VITE_LIVE_HOST_URL || "https://host.gymlive.app";

/**
 * Open the host broadcast view for a live room.
 *
 * GYM-911: the host app's token endpoint is authenticated now (GYM-893), and it
 * lives on a different origin — so this tab's session does not travel with the
 * `window.open`. We hand the access token over in the URL FRAGMENT, which the
 * browser never sends to a server; the host app stores it and strips the hash on
 * boot. Same handoff the dashboard already uses for "login as club".
 *
 * Shared by the S&C and fitness (DCC) schedules so the two flows stay identical.
 */
export function openLiveHost(params: {
  roomID: string;
  /** Live row id. Lets the host app ask for a room-scoped token. */
  liveID?: string;
  /** Shown in the host app's header. */
  hostName?: string;
}) {
  const { roomID, liveID, hostName } = params;

  const query = new URLSearchParams({ roomID, role: "host" });
  if (hostName) query.set("hostName", hostName);
  if (liveID) query.set("liveID", liveID);

  const token = localStorage.getItem(TOKEN_KEY);
  const fragment = token
    ? `#access_token=${encodeURIComponent(token)}`
    : "";

  window.open(
    `${LIVE_HOST_URL}/live_stream/?${query.toString()}${fragment}`,
    "_blank",
    "noopener",
  );
}
